module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allDeployments":"All Deployments","manage":"Manage","overview":"Overview","topology":"Topology"}}')
  delete Component.options._Ctor
}
